module.exports = "/_next/static/images/caravan-monotone-4b29df18c99b3eeb0a4e96022b1867eb.svg";